import type { ReactElement } from "react";
import { Link } from "react-router-dom";
import { EmptyState } from "../components/ui";

export function NotFoundPage(): ReactElement {
  return (
    <main className="auth-page">
      <EmptyState
        emoji="🧭"
        title="Essa página não existe"
        description="O link pode ter mudado de lugar."
        action={
          <Link className="btn btn-primary" to="/app">
            Ir para o início
          </Link>
        }
      />
    </main>
  );
}
